// src/redux/sagas/rootSaga.js
import { takeEvery, call, put } from "redux-saga/effects";
import axios from "axios";
import { API_REQUEST, API_SUCCESS, API_FAILURE } from "../Redux/apiActions";

// Requests currently waiting for a response, keyed by method + url + body.
// An identical request fired before the first one resolves (e.g. repeated
// taps on VERIFY) is dropped; the first request's callbacks handle the UI.
const inFlight = new Set();

function* handleApi(action) {
  const {
    url,
    method = "GET",
    data = null,
    headers = {},
    handleSuccess,
    handleError,
    onSuccessKey,
    onErrorKey,
  } = action.payload;
  const key = onSuccessKey || url;
//logger.log("onErrorKey",onErrorKey)
  const requestKey = `${method.toUpperCase()} ${url} ${data instanceof FormData ? Math.random() : JSON.stringify(data)}`;
  if (inFlight.has(requestKey)) return;
  inFlight.add(requestKey);
  try {
    const jwtToken = localStorage.getItem("UserJWTAuth");
    const config = {
      url,
      method,
      headers: {
        "Content-Type": "application/json",
        ...headers,
        ...(jwtToken ? { Authorization: `Bearer ${jwtToken}` } : {}),
      },
      data,
    };

    const response = yield call(axios, config);

    //logger.log("response saga",response)

    // Dispatch generic success for state
    yield put({ type: API_SUCCESS, payload: { key, data: response.data } });

    // Dispatch custom success action if needed
    if (onSuccessKey) yield put({ type: onSuccessKey, payload: response.data });

    // Call callback
    if (handleSuccess) handleSuccess(response);
  } catch (error) {
    yield put({ type: API_FAILURE, payload: { key, error: error.message } });

    if (onErrorKey) yield put({ type: onErrorKey, payload: error.message });

    if (handleError) handleError(error);
  } finally {
    inFlight.delete(requestKey);
  }
}

export default function* rootSaga() {
  yield takeEvery(API_REQUEST, handleApi);
}
